/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Invalid_Email_FormatInputs */

const en_auth_invalid_email_format = /** @type {(inputs: Auth_Invalid_Email_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid email format`)
};

const es_auth_invalid_email_format = /** @type {(inputs: Auth_Invalid_Email_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de correo electrónico no válido`)
};

/**
* | output |
* | --- |
* | "Invalid email format" |
*
* @param {Auth_Invalid_Email_FormatInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_invalid_email_format = /** @type {((inputs?: Auth_Invalid_Email_FormatInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Invalid_Email_FormatInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_invalid_email_format(inputs)
	return en_auth_invalid_email_format(inputs)
});